import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColorPicker = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 29,
	viewBox: "0 0 30 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_361_13499)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.19074 23.7125L14.0183 17.885L11.1347 15.0014L5.30713 20.8289L5.29587 23.7238L8.19074 23.7125ZM0.233807 27.154L2.67059 24.7172L2.68988 19.739L15.8719 6.55604L14.2244 4.9085L16.6961 2.43681L18.3518 4.09249L20.8313 1.61299C22.6515 -0.207096 25.6024 -0.207096 27.4225 1.61299C29.2426 3.43318 29.2426 6.38416 27.4225 8.20424L24.9396 10.6803L26.5829 12.3236L24.1112 14.7953L22.4636 13.1477L9.28069 26.3298L4.33441 26.349L1.88168 28.8017L0.233807 27.154ZM21.2279 11.912L17.1077 7.79177L4.43435 20.4651L4.41873 24.601L8.55458 24.5853L21.2279 11.912Z",
			fill: "white",
			stroke: "#a4ada4",
			strokeWidth: .3
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_361_13499",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 29,
			height: 29,
			fill: "white",
			transform: "matrix(-1 0 0 1 29.0107 0.00891113)"
		})
	}) })]
});
export default SvgColorPicker;
